import { AnimatePresence, motion } from "motion/react";
import React from "react";
import { useTranslation } from "../localization";
import { Spinner } from "../spinner";
import type { ChildrenProps } from "../types";

export interface ChartWrapperProps extends ChildrenProps {
	isLoading: boolean;
}

export function ChartWrapper({ children, isLoading }: ChartWrapperProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<React.Fragment>
			<AnimatePresence mode="wait">
				{isLoading ? (
					<motion.div
						key="loading"
						className="flex-col flex-center gap-4 pb-[10%] w-full h-full"
						initial={initial}
						animate={animate}
						exit={exit}
						transition={transition}
					>
						<Spinner />
						<p className="label">{t("general.loading")}</p>
					</motion.div>
				) : (
					<motion.div
						key="content"
						className="w-full h-full"
						initial={initial}
						animate={animate}
						exit={exit}
						transition={transition}
					>
						{children}
					</motion.div>
				)}
			</AnimatePresence>
		</React.Fragment>
	);
}

const initial = { opacity: 0 };
const animate = { opacity: 1 };
const exit = { opacity: 0 };
const transition = { duration: 1 };
